import { variables } from './_variables.js';
let { isMobile } = variables();

const settings = {
  orderAnimateClass: ".group-animate-wrap",
  animateClass: ".js-animate-in",
  options: {
    repeatAnimation: false,
    delay: 350,
  },
};
const applyAction = (target, isVisible, observer = null) => {
  target.classList[isVisible ? "remove" : "add"]("is-hide");
  target.classList[isVisible ? "add" : "remove"]("scroll-in");
  if (!settings.options.repeatAnimation && isVisible && observer) {
    observer.unobserve(target);
  }
};
export const animateInObserver = () => {
  const fadeInObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.boundingClientRect.top < window.innerHeight) {
          applyAction(entry.target, true, fadeInObserver);
        }
      });
    },
    {
      rootMargin: '50px',
      threshold: 0.25,
    }
  );
  const fadeOutObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && settings.options.repeatAnimation) {
          applyAction(entry.target, false, fadeOutObserver);
        }
      });
    },
    {
      threshold: 0.25,
    }
  );
  const targets = document.querySelectorAll(settings.animateClass);
  Array.from(targets)
    .filter((target) => !target.closest(settings.orderAnimateClass))
    .forEach((target) => {
      fadeInObserver.observe(target);
      fadeOutObserver.observe(target);
    });
};
const orderAnimateInObserver = () => {
  const orderInObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.boundingClientRect.top < window.innerHeight) {
          const wrapper = entry.target.closest(settings.orderAnimateClass);
          requestAnimationFrame(() => {
            const aniamteDelay = wrapper.getAttribute("data-animate-delay") || 0;
            const delay = parseInt(wrapper.getAttribute("data-delay")) || settings.options.delay;
            const adjustedDelay = isMobile ? delay / 2 : delay;
            const index = Array.from(wrapper.querySelectorAll(settings.animateClass)).indexOf(entry.target);
            setTimeout(() => applyAction(entry.target, true, orderInObserver), adjustedDelay * index);
          });
        }
      });
    },
    {
      rootMargin: '50px',
      threshold: 0.25,
    }
  );
  const orderOutObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && settings.options.repeatAnimation) {
          _.applyAction(entry.target, false, orderOutObserver);
        }
      });
    },
    {
      threshold: 0,
    }
  );
  document.querySelectorAll(settings.orderAnimateClass).forEach((wrapper) => {
    wrapper.querySelectorAll(settings.animateClass).forEach((target) => {
      orderInObserver.observe(target);
      orderOutObserver.observe(target);
    });
  });
};


export const followBtns = () => {
  const target = document.querySelector('.js-follow-btns');
  const triggerEl = document.querySelector('.sec-about');
  const scrollEndEl = document.querySelector('.sec-about-recruit') ? document.querySelector('.sec-about-recruit') : document.querySelector('.footer');

  window.addEventListener('scroll', function() {
    const windowHeight = window.innerHeight;
    // 下層ページ（triggerElがない場合）とトップページで条件分岐
    const triggerPosition = triggerEl 
      ? triggerEl.getBoundingClientRect().top 
      : window.scrollY > 100 ? 0 : windowHeight + 100;
    const scrollEndRect = scrollEndEl.getBoundingClientRect();
    
    if (triggerPosition > windowHeight || scrollEndRect.top <= windowHeight) {
      target.classList.remove('is-active');
    } else {
      target.classList.add('is-active');
    }
  });
};


export const splitText = ($delay=100) => {
  const baseTexts = document.querySelectorAll('.js-split-text');
  
  baseTexts.forEach((baseText, index) => {
    baseText.classList.add('group-animate-wrap');
    baseText.dataset.delay = baseText.dataset.delay ? baseText.dataset.delay : $delay;
    
    const splitText = baseText.textContent.split('');
    baseText.innerHTML = splitText.map((text) => {
      if (text === ' ') {
        return `<span class="js-animate-in" data-animate="slide-in-up">&nbsp;</span>`;
      }
      return `<span class="js-animate-in" data-animate="slide-in-up">${text}</span>`;
    }).join('');
  });

  // 同じファイル内のanimateInObserverを実行
  orderAnimateInObserver();

  return baseTexts;
}





const init = () => {
  document.querySelectorAll(settings.animateClass).forEach((target) => target.classList.add("is-hide"));
  animateInObserver();
  orderAnimateInObserver();
};

export default init;
